import React from 'react'

import { getUnauthedFallbackUrl } from 'common/api'
import { AuthShieldComponent } from 'components/AuthShield'

import ScoirApplyIcon from '../components/ScoirApplyIcon'
import SidebarListItem from '../components/SidebarListItem'

/**
 * ApplyWithScoir version of sidebar for responsive designs
 * @returns ApplyWithScoir Component
 */
const ApplyWithScoir = () => {
  return (
    <AuthShieldComponent
      id="main-nav-apply-with-scoir-list-item"
      label="Apply with Scoir"
      component={SidebarListItem}
      iconComponent={<ScoirApplyIcon />}
      propsAuthed={{
        to: `${import.meta.env.BASE_URL}/app-profile`,
      }}
      propsUnauthed={{
        href: getUnauthedFallbackUrl(),
      }}
    />
  )
}

export default ApplyWithScoir
